import { createContext, useState} from "react";
import Home from "../ContentArea/Home/Home";
import NewAccounDescript from "../ContentArea/Cadastro/CadastroDescript/NewAccountDescript"
import Acessos from "../ContentArea/Dashboard/DashboardItems/Acessos";
import PlaySimbolBlack from "../MusicPlayer/play_arrow_black.png"
import UserNotLogged from "../ContentArea/Dashboard/DashboardItems/UserNotLogged";
import Chonchon from '../Banner/img/steel_chocho.gif'
import MeuCadastro from "../ContentArea/Dashboard/DashboardItems/MeuCadastro";
import SolicitarVip from "../ContentArea/Dashboard/DashboardItems/SolicitarVip";

const PageContext = createContext();



function PageProvider({children}){

    const [page, setPage] = useState();
    const [registerData, setRegisterData] = useState();
    const [registerPageSection, setRegisterPageSection] = useState(<NewAccounDescript />);
    const [confirmationCode, setConfirmationCode] = useState();
    const [dashBoardPageSelection, setDashboardPageSelection] = useState(<SolicitarVip />);
    const [user, setUser] = useState({userName: "Anonimo"});
    const [userCharacters, setUserCharacters] = useState([])
    const [isLogged, setIsLogged] = useState(false)
    const [noticeMessage, setNoticeMessage] = useState("");
    const [popMenuContent, setPopMenuContent] = useState("Hello World")
    const [managedAccess, setManagedAcess] = useState(null)
    const [ userAccessList, setUserAccessList] = useState([])
    const [dashBoardInitialPage, setDashboardInitialPage] = useState(<UserNotLogged />);
    const [flyingpetImage, setFlyingPetImage] = useState(Chonchon)
    const [ToolTipContent, setToolTipContent] = useState();

    //Global Music Player Variables
    const [musicDuration, setMusicDuration] = useState("00:01:14")
    const [musicDurationTimeLeft, setMusicDurationTimeLeft] = useState(0)
    const [musicName, setMusicName] = useState("Title")
    const [musicNumber, setMusicNumber] = useState('01');
    const [controlObject, setcontrolObject] = useState(PlaySimbolBlack)



    return(
        <PageContext.Provider value={
            {page, setPage,
            registerData, setRegisterData,
            registerPageSection, setRegisterPageSection, 
            confirmationCode, setConfirmationCode,
            dashBoardPageSelection, setDashboardPageSelection,
            user, setUser,
            isLogged, setIsLogged,
            userCharacters, setUserCharacters,
            noticeMessage, setNoticeMessage,
            popMenuContent, setPopMenuContent,
            managedAccess, setManagedAcess,
            userAccessList, setUserAccessList,
            musicDuration, setMusicDuration,
            musicDurationTimeLeft, setMusicDurationTimeLeft,
            musicName, setMusicName,
            musicNumber, setMusicNumber,
            controlObject, setcontrolObject,
            dashBoardInitialPage, setDashboardInitialPage,
            flyingpetImage, setFlyingPetImage,
            ToolTipContent, setToolTipContent
        }
            }>
            {children}
        </PageContext.Provider>
    )
}

export default PageProvider;
export { PageContext} ;